export default __webpack_public_path__ + "static/media/menu_buy_icon_okara.6efbf2c0.svg";